export class UpdateRestoreAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateAwsRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateGcpRestoreAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
